import React from "react";
import coldDrink from "../images/rodo_cold.webp";
import rodoProducts from "../images/rodo_products_group.webp";

const Main = () => {
  return (
    <div className="main brush-bottom">
      <div className="container">
        <div className="header">
          <span>
            Brew Joy...
            <br />
            Sip Comfort
          </span>
        </div>
        <div className="sub-text">
          <main>
            Experience the Bold, Refreshing
            <br />
            Taste of Rodo Tea
            <br />
            Your Hassle-Free Hibiscus Brew!
          </main>
        </div>
        <div className="header-img">
          <img src={rodoProducts} alt="delicious rodo hibiscus tea" />
        </div>
      </div>
      {/* <div className="header-image-group"> */}

      {/* </div> */}
    </div>
  );
};

export default Main;
